$(function() {
    String.prototype.cleanup = function() {
        var str = this;
        return str.replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/#/g, '').replace(/\./g, '').replace(/,/g, '').replace(/@/g, '').replace(/:/g, '');
    };

    $('[data-toggle="tooltip"]').tooltip();


    $('.remove_li').click(function(e) {
        e.preventDefault();
        $this = $(this);
        debugger;
        bootbox.confirm('ნამდვილად გინდათ წაშლა?', function(result){
            if (result) {
                $this.parent('li').remove();
            }
        });
    });


    convertFormVarsToBase64($('.search'));
    segmentChanger($('.per_page_changer'));

    $('.table-add-row').click(function(e) {
        e.preventDefault();
        var table = $('#' + $(this).data('tableid'));
        var tfoot = table.find('tfoot');
        var tbody = table.find('tbody');
        var tr = tfoot.find('tr').clone();
        tr.appendTo(tbody).find('.table-add-row').removeClass('table-add-row').addClass('table-delete-row').addClass('btn-danger').click(function(e) {
            e.preventDefault();
            $this = $(this);
            debugger;
            bootbox.confirm('ნამდვილად გინდათ წაშლა?', function(result){
                if (result) {
                    $this.parents('tr').remove();
                }
            });

        }).find('.icon-plus').removeClass('icon-plus').addClass('icon-remove');
        tfoot.find('input, select, textarea').val('');
    });

    $('.table-delete-row').on('click', function(e) {
        e.preventDefault();
        $this = $(this);
        debugger;
        bootbox.confirm('ნამდვილად გინდათ წაშლა?', function(result){
            if (result) {
                $this.parents('tr').remove();
            }
        });
    });

    $("select").change(function() {
        var selected = $(this).find("option:selected");
        $(this).find("option").each(function() {
            if ($(this).attr('selected') == 'selected') {
                $(this).removeAttr('selected');
            }
        });
        selected.attr('selected', 'selected');
    });

    $(document.body).on('change', '.select-ajax', function() {
        var tar_par;
        var target;
        if ($(this).data('target-parent')) {
            tar_par = $(this).parents($(this).data('target-parent'));
            target = $(tar_par.find($(this).data('target')));
        } else {
            target = $($(this).data('target'));
        }
        target.html('');
        $.ajax({
            url: $(this).data('url'),
            type: "POST",
            data: {
                'query': $(this).val()
            }
        }).done(function(data) {
            ret = JSON.parse(data);
            for (k in ret) {
                $('<option/>', {
                    'value': k
                }).html(ret[k]).appendTo(target);
            }
        });
    });

    $('.typeahead').each(function() {
        var putin = $(this).data('putin');
        if (putin) {
            var items = $(this).data('items');
            var cont = $('#' + putin);
            for (var k in items) {
                //console.log(items[k]);
                var name = $(this).data('name');
                addCodeItem(items[k], cont, name, k);
            }
        }
    });

    $('.jstabs a').click(function(e) {
        e.preventDefault();
        $(this).tab('show');

        var target;
        if ($(this).data('selector')) {
            target = $($(this).data('selector'));
            target.val($(this).data('value'));
        }
    });


    /*$('.datepicker').datepicker({
        weekStart: 1,
        format: 'yy-mm-dd'
    }).on('changeDate', function() {
        $(this).datepicker('hide');
    });*/


    initDateTime();

    initDate();


    $('.typeahead').typeahead({
        source: function(query, process) {
            $.ajax({
                url: this.$element.data('url'),
                type: "POST",
                data: {
                    'query': query
                }
            }).done(function(data) {
                var ret = JSON.parse(data);
                process(ret);
            });
        },
        render: function(items) {
            var that = this;
            items = $(items).map(function(i, item) {
                var id = item.match(/{.*}/);
                var data_id;
                if (id) {
                    data_id = id[0].replace(/{|}/g, '');
                } else {
                    data_id = item;
                }
                var text = item.replace(/{.*}/g, '');
                i = $(that.options.item).attr({
                    'data-value': text,
                    'data-id': data_id
                });
                i.find('a').html(that.highlighter(text));
                return i[0];
            });
            items.first().addClass('active');
            this.$menu.html(items);
            return this;
        },
        updater: function(item) {
            var putin = this.$element.data('putin');
            if (putin) {
                var cont = $('#' + putin);
                addCodeItem(item, cont, this.$element.data('name'), this.$menu.find('.active').data('id'));
            } else {
                return item;
            }
        }
    });

    // @FIXME
    $('.address').typeahead({
          minLength: 3,
          highlight: true
        },
        {
          name: 'my-dataset',
          source: ["Unites States", "Mexico", "Canada", "Cuba", "Guatemala"]
        }
    );

    // initialize some plugins
    $(".tip").tooltip();
    $(".pop").popover();
    $('.drop').dropdown();

    //enables select2 searchbox in bootstrap modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};

    initSelect2();
    initSelect2WithTags();
    /*initSelect2Min();*/

    /*$('.datetime').datepicker({
        firstDay: 1,
        dateFormat: 'yy-mm-dd'

    });*/


    /*$('.date').datepicker({
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        yearRange : 'c-50:c',
        dateFormat: 'dd-mm-yy'
    });*/



    GeoKBD.map({fields: ['.geo']});

    // initialize TinyEMCE
    if (typeof tinymce != 'undefined') {
        tinymce.baseURL = Main.base_url+"/res/js/tinymce/";
        tinymce.init({
            selector: ".editor",
            //theme : 'modern',
            convert_fonts_to_spans : true,
            resize: 'both',
            document_base_url: Main.base_url,
            menubar: false,
            plugins: "paste code textcolor anchor hr image link media table",
            cleanup_on_startup : true,
            cleanup : true,
            paste_auto_cleanup_on_paste : true,
            paste_remove_styles: true,
            paste_remove_styles_if_webkit: true,
            paste_strip_class_attributes: true,
            toolbar: "bold italic underline forecolor backcolor styleselect formatselect fontselect fontsizeselect | undo redo | bullist numlist outdent indent removeformat code | link unlink image media"
        });
    }


    $('.form_clear').on('click', function(event){
        event.preventDefault();
        $this = $(this);
        var form_id = $this.data('form-id');
        var form = $('#'+form_id);
        var fields = form.find('.form_filter');
        $.each(fields, function(index, fld){
            var field = $(fld);
            var type = field.attr('type');
            var val = field.data('default-value');
            if (val === undefined) {
                if (field.is('input')) {
                    val = '';
                } else if (field.is('select')) {
                    val = 0;
                } else {
                    val = '';
                }
            }
            field.val(val);
        });
        form.submit();
    });


    // init color picker
    initSpectrum();


    $('.phone_home').mask('(000) 000-00-00');
    $('.phone_mobile').mask('(000) 00-00-00');

    $('#summary-controls-btn').bootstrapToggle({
        on: Main.txts.toggleOn,
        off: Main.txts.toggleOff,
    });

});


function initSpectrum() {
    $('.colorpicker').spectrum({
        preferredFormat: "hex",
        clickoutFiresChange: true,
        cancelText: 'Cancel',
        chooseText: 'OK',
        showInput: true,
        allowEmpty: true,
        showSelectionPalette: true,
        showPalette: true,
        palette: [
            ["#000","#444","#666","#999","#ccc","#eee","#f3f3f3","#fff"],
            ["#f00","#f90","#ff0","#0f0","#0ff","#00f","#90f","#f0f"],
            ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
            ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
            ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
            ["#c00","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
            ["#900","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
            ["#600","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
        ],
        hideAfterPaletteSelect:true
    });
}


function openDataLoadWindow(backup_id) {
    $('#DataLoaderModal').modal({
            backdrop: 'static',
            keyboard: false
    });
    $('#DataLoaderModal').on('hidden.bs.modal', function() {
        window.location.href = Main.dataloader.current_url+'?'+Math.random();
    });
    processDataLoad(0);
};


function clearDataLoad(offset) {


};

function processDataLoad(offset) {
    offset = parseInt(offset);
    var url = Main.dataloader.ajax_url+'/'+offset;
    $.ajax({
        type: 'GET',
        url: url,
        cache: false,
        timeout: 0,
        dataType: "json",
        beforeSend:function(){
            // nothing
        },
        success: function(res, textStatus, jqXHR) {
            var status = res.status;

            if (status == 'ok') {
                percent = parseInt(res.data.progress);
                $('#DataLoaderModal .bar').css('width',percent+'%').attr('aria-valuenow', percent);
                $('#DataLoaderModal #bar-percentage').html(percent+'%');
                if (res.data.completed) {
                    $('#DataLoaderModal .progress').removeClass('active');

                    if (res.data.print_url) {
                        $('#DataLoaderModal .modal-footer .modal-a-print').attr('href', res.data.print_url);
                        $('#DataLoaderModal .modal-footer .modal-a-print').removeClass('hide');
                    }

                    if (res.data.export_url) {
                        $('#DataLoaderModal .modal-footer .modal-a-export').attr('href', res.data.export_url);
                        $('#DataLoaderModal .modal-footer .modal-a-export').removeClass('hide');
                    }


                    $('#DataLoaderModal .modal-msg').addClass('alert').addClass('alert-success');
                    $('#DataLoaderModal .modal-msg').html('წარმატებით დასრულდა');


                    $('#DataLoaderModal .modal-footer .modal-close').html('დახურვა');
                } else {
                    processDataLoad(res.data.offset);
                    //console.log(res.data);
                }
            } else {
                $('#DataLoaderModal .modal-msg').addClass('alert').addClass('alert-error');
                $('#DataLoaderModal .modal-msg').html('შეცდომა');
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            var error = textStatus+' '+errorThrown;
            $('#DataLoaderModal .modal-msg').addClass('alert').addClass('alert-error');
            $('#DataLoaderModal .modal-msg').html('შეცდომა '+error);
        },
        complete: function(jqXHR, textStatus) {
            // nothing
        }
    });
}


function convertFormVarsToBase64($form) {
    $form.submit(function(e) {
        e.preventDefault();
        var url = $(this).attr('action') + '/';
        var url_params = {};
        $.each($(this).serializeArray(), function() {
            url_params[this.name] = this.value;
        });
        top.location.href = url + Base64.encode(JSON.stringify(url_params));
    });
}

function segmentChanger($select) {
    $select.on("change", function(e) {
        var segmentN = $select.data('segment');
        var urlSplited = document.location.href.split(document.location.host);
        var segments = urlSplited[1].split('/');

        if (document.location.hash !== "") {
            segments[segments.length - 1] = segments[segments.length - 1].split(document.location.hash)[0];
        }
        segments[segmentN] = $(this).val();
        //to segmentN segments.length-ze metian minimum2 it mashi iqneba ramdenime undefined
        //["", "admin", "controler", "param", "index.cs#asd", undefined, undefined, "s"]
        //an ese ["", "admin", "controler", "param", "", undefined, undefined, "s"]
        for (var i = 1; i < segments.length; i++) {
            if (typeof segments[i] == "undefined" || segments[i] === "") segments[i] = 0;
        }
        //exa ese iqneba ["", "admin", "controler", "param", "index.cs#asd", 0, 0, "s"]
        if (document.location.hash !== "") {
            segments[segments.length - 1] = segments[segments.length - 1] + document.location.hash;
        }
        urlSplited[1] = segments.join('/');
        // "/admin/controler/param/index.cs#asd/0/0/s"
        var newHref = urlSplited.join(document.location.host);
        // isev agdgeba urlSplited
        document.location.href = newHref;
    });
}

function addCodeItem(item, cont, name, val) {
    item = '' + item;

    if (cont.find('#' + item.cleanup()).length === 0) {
        var li = $('<li/>', {
            id: item.cleanup()
        });
        var input = $('<input/>', {
            type: 'hidden',
            'name': name,
            value: val
        }).appendTo(li);
        var a = $('<a/>', {
            href: '#',
            text: item,
            'class': 'remove_li'
        }).appendTo(li).click(function(e) {
            e.preventDefault();
            $this = $(this);
            debugger;
            bootbox.confirm('ნამდვილად გინდათ წაშლა?', function(result){
                if (result) {
                    $this.parent('li').remove();
                }
            });
        });
        var i = $('<i/>', {
            'class': 'icon-remove pull-right'
        }).appendTo(a);
        cont.append(li);
    }
}


function initDateTime() {
    $('.timepicker').datetimepicker({
        format: 'DD-MM-YYYY HH:mm:ss',
        stepping: 10,
        locale: Main.locale_abbr,
        showClear: true
    });
}
function initDate() {
    $('.datepicker, .datetime, .date').datetimepicker({
        format: 'DD-MM-YYYY',
        locale: Main.locale_abbr,
        showClear: true
    });
}

function initSelect2() {
    $('.select2').select2();
}

function initSelect2WithTags() {
    $('.select2withtags').select2({
        tags: true
    });
}

/*function initSelect2Min() {
    $('.select2min').select2({
        minimumResultsForSearch: -1
    });
}*/
